import { useRef } from "react";
import { useFrame } from '@react-three/fiber';

export default function Book() {
    const bookRef = useRef();

    useFrame(( state, delta ) => {
        if (bookRef.current) {
            bookRef.current.rotation.z += 0.5 * delta;
            bookRef.current.rotation.x += 0.3 * delta;

        }
    });

    return (
        <mesh ref={bookRef} position={[-3.25, 4.4, -0.4]}>
            <boxGeometry args={[0.2, 2, 1.5]} />
            <meshStandardMaterial color="blue" />
        </mesh>
    );
}